class AdvertiserCtrl {

    constructor($scope, $routeParams, $uibModal, $filter, ApiService, CONTENT_TYPE, EVENTS, $location, Notification, $rootScope) {

        this.$scope = $scope;

        $scope.pagination = {
            itemsPerPage: 25,
            page: 1
        };

        $scope.advertiser = null;
        $scope.campaigns = [];
        $scope.campaign = null;
        $scope.accountId = $routeParams.accountId;
        this.$scope.selectAll = false;
        this.$routeParams = $routeParams;
        this.ApiService = ApiService;
        this.$uibModal = $uibModal;
        this.contentType = CONTENT_TYPE.CAMPAIGN;
        this.$filter = $filter;
        this.advertiserId = this.$routeParams.advertiserId;
        this.$location = $location;
        this.$routeParams = $routeParams;
        this.Notification = Notification;
        this.EVENTS = EVENTS; 

        $scope.loading = true;
        $scope.noResults = false;
        $scope.error = false;
        $scope.accountId = $routeParams.accountId;
        $scope.advertiserId = $routeParams.advertiserId;

        this.$scope.isCopying = false;
        this.$scope.isDeleting = false;
        this.$scope.tableSort = "name";   
        $scope.itemsSelected = false;
        $scope.selectedItems = {};

        $scope.errorMessage = '';

        ApiService.get(CONTENT_TYPE.ADVERTISER, $routeParams.advertiserId) 
            .then((response) => {
                $scope.advertiser = response.data;
                $scope.$emit(EVENTS.SET_TITLE, $scope.advertiser.name);
            }, (response) => {
                console.error(response);
                $scope.error = true;
            });

        $scope.$watch('selectedItems', (newVal) => {
            let selected = false;
            Object.keys(newVal).forEach(key => {
                if(newVal[key]) { selected = true; }
            });
            $scope.itemsSelected = selected;
        },  true);

        $scope.$watch('tableFilter', this.campaignFilter.bind(this));

        this.$scope.addCampaign = this.addCampaign.bind(this);
        this.$scope.refreshCampaigns = this.refreshCampaigns.bind(this);
        this.$scope.updateCampaign = this.updateCampaign.bind(this);
        this.$scope.deleteCampaign = this.deleteCampaign.bind(this);
        this.$scope.selectOrDeselectAll = this.selectOrDeselectAll.bind(this);
        this.$scope.deleteSelected = this.deleteSelected.bind(this);
        this.$scope.copySelected = this.copySelected.bind(this);
        this.$scope.copy = this.copy.bind(this);
        this.$scope.sortTable = this.sortTable.bind(this);

        $rootScope.$on(this.EVENTS.COPY_COMPLETE, (event, entity) => {
            if(entity.advertiserId == this.advertiserId) {
                this.refreshCampaigns();
            }
            this.$scope.isCopying = false;
        });

        this.$scope.refreshCampaigns();
    }

    copySelected() {
        let toCopy = [];

        $.each(this.$scope.selectedItems, (campaignId, selected) => { 
            if(selected) {
                let campaign = this.$scope.campaigns.filter(c => c.id == campaignId)[0];
                toCopy.push(campaign);
            }
        });

        let multiple = true;

        if(toCopy.length == 1) { 
            toCopy = toCopy[0]; 
            multiple = false;
        }

        this.copy(toCopy, multiple);

    }

    sortTable(key) {
        if (this.$scope.tableSort === '-' + key) {
            this.$scope.tableSort = key;
        } else {
            this.$scope.tableSort = '-' + key;
        }
    }

    addCampaign() {
        var self = this;
        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'advertiser/add-campaign.html',
            controller: 'AddItemCtrl',
            resolve: {
            }
        });
        modalInstance.result.then((newItem) => {
            this.createCampaign(newItem);
        }, () => {

        });

    }

    updateCampaign(newItem) {
        let campaign = {
            campaignId: newItem.id,
            name: newItem.name
        };

        this.ApiService.update(this.contentType, campaign)
            .then((response) => {
                this.refreshCampaigns();
            }, (response) => {
                console.error(response);
                this.$scope.error = true;
        });
    }

    createCampaign(newItem) {
        let campaign = {
            campaignId: this.campaignId,
            advertiserId: this.$scope.advertiser.id,
            name: newItem.name
        };

        this.ApiService.create(this.contentType, campaign)
            .then((response) => {
                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Campaign "' + response.data.name + '" created.'});
                if (newItem.createMore != null && newItem.createMore === true) {
                    this.addCampaign();
                    this.refreshCampaigns();
                } else {
                    this.$location.url('/account/' + this.$scope.accountId + '/' + response.data.advertiserId + '/campaign/' + response.data.id);
                }
            }, (response) => {
                console.error(response);
                this.$scope.error = true;
            });
    }

    deleteCampaign(campaign) {
        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {

            this.$scope.isDeleting = true;
            this.ApiService.delete(this.contentType, campaign.id)
                .then((response) => {
                    this.refreshCampaigns();
                    this.$scope.isDeleting = false;
                }, (response) => {
                    console.error(response);
                    this.$scope.isDeleting = false;
                    this.$scope.error = true;
                });
        },() => {
            this.$scope.isDeleting = true;
        });
    }

    refreshCampaigns() {
        this.$scope.noResults = false;
        this.$scope.loading = true;
        this.ApiService.list(this.contentType, "advertiser=" + this.advertiserId)
            .then((response) => {
                this.$scope.campaigns = response.data;
                this.campaignFilter();
                this.$scope.loading = false;
                if (this.$scope.campaigns.length === 0) {
                    this.$scope.noResults = true;
                }
            }, (response) => {
                this.$scope.campaigns = [];
                if (response.status === 404) {
                    this.$scope.noResults = true;
                } else {
                    this.$scope.error = true;
                }
                this.$scope.loading = false;
            });
    }

    selectOrDeselectAll() {
        this.$scope.selectAll = ! this.$scope.selectAll;
        this.$scope.selectedItems = {};
        if(this.$scope.selectAll) {
            this.$scope.campaigns.forEach(campaign => { 
                this.$scope.selectedItems[campaign.id] = true;
            });
        }
    }

    deleteSelected() {
        let toDelete = [];

        $.each(this.$scope.selectedItems, (campaignId, selected) => { 
            if(selected) {
                let campaign = this.$scope.campaigns.filter(c => c.id == campaignId)[0];
                toDelete.push(campaign);
            }
        });

        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {

            this.$scope.isDeleting = true;
            toDelete.forEach((campaign, i) => {
                this.ApiService.delete(this.contentType, campaign.id)
                    .then((response) => {
                        if(i == toDelete.length - 1) {
                            this.refreshCampaigns();
                            this.$scope.isDeleting = false;
                        }
                    }, (response) => {
                        console.error(response);
                        this.$scope.error = true;
                        this.$scope.isDeleting = false;
                    });
            });
        },() => {
            this.$scope.isDeleting = true;
        });
    }

    campaignFilter() {
            let filtered = this.$filter('filter')(this.$scope.campaigns, this.$scope.tableFilter);
            this.$scope.availableItems = filtered.length;
    }

    copy(campaign, multiple) {

        this.$scope.isCopying = true;

        let titleName = "";

        if(!!!multiple) { 
            multiple = false; 
        }
        else if(!multiple) {
            titleName = campaign.name;
        }

        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'components/copy-entity-modal.html',
            controller: 'CopyEntityCtrl',
            resolve: {
                entity: () => campaign,
                multiple: () => multiple,
                title: () => "Choose a campaign to copy " + titleName + " to..."
            }
        });

        modalInstance.result.then(item => this.$scope.isCopying = false, () => this.$scope.isCopying = false);
    }

}


angular.module("cpm").controller("AdvertiserCtrl", ['$scope', '$routeParams', '$uibModal', '$filter', 'ApiService', 'CONTENT_TYPE', 'EVENTS', '$location', 'Notification', '$rootScope', AdvertiserCtrl]);

